/* eslint-disable react/jsx-key */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import DomainIcon from '@mui/icons-material/Domain';
// import DownloadIcon from '@mui/icons-material/Download';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import WorkIcon from '@mui/icons-material/Work';
import {
  Box,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Button,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  // Tooltip,
  Typography,
} from '@mui/material';
import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { pdf } from '@react-pdf/renderer';
import { CandidateSubmissionType } from 'components/JobQueue/utils';
import { Loader } from 'components/loader';
// import { SalesRoute } from 'config';
import { saveAs } from 'file-saver';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatPhoneNumber } from 'utils/Helpers';

interface JobQueueTableProps {
  selectedRows: string[];
  onRowSelect: (id: string) => void;
  onSelectAll: (selected: boolean) => void;
  loading?: boolean;
  users: CandidateSubmissionType[];
  jobId: string;
  goal?: string;
  jobTitle?: string;
  expFrom?: number | null;
  expTo?: number | null;
}

const CandidateTable: React.FC<JobQueueTableProps> = ({
  // selectedRows,
  // onRowSelect,
  // onSelectAll,
  loading = false,
  users,
  jobId,
  goal,
  jobTitle,
  expFrom,
  expTo,
}) => {
  // const { VIEWipriseCANDIDATE } = SalesRoute;
  const navigate = useNavigate();
  const [openPercentageModal, setOpenPercentageModal] = useState(false);
  const [goalSectionHeight, setGoalSectionHeight] = useState<number | 'auto'>(
    'auto',
  );
  const [isDragging, setIsDragging] = useState(false);
  const [formulaStepsExpanded, setFormulaStepsExpanded] = useState(false);
  const contentRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (openPercentageModal && contentRef.current) {
      const height = contentRef.current.scrollHeight;
      const restrictedHeight = Math.max(100, Math.min(600, height));
      setGoalSectionHeight(restrictedHeight);
    }
  }, [goal, openPercentageModal]);
  const [selectedCandidate, setSelectedCandidate] =
    useState<CandidateSubmissionType | null>(null);

  // Resize handlers for the goal section
  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleMouseMove = React.useCallback(
    (e: MouseEvent) => {
      if (!isDragging) return;

      const modalElement = document.querySelector('[data-goal-container]');
      if (!modalElement) return;

      const rect = modalElement.getBoundingClientRect();
      const newHeight = Math.max(100, Math.min(600, e.clientY - rect.top));
      setGoalSectionHeight(newHeight);
    },
    [isDragging],
  );

  const handleMouseUp = React.useCallback(() => {
    setIsDragging(false);
  }, []);

  React.useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
    }
  }, [isDragging, handleMouseMove, handleMouseUp]);

  const navigateTo = (candidate: CandidateSubmissionType) => {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const basePath = pathSegments.length > 0 ? `/${pathSegments[0]}` : '/sales';
    navigate(
      `${basePath}/job-post/view-job/iprise-job/candidate/${jobId}/${candidate?.candidate?.id}`,
      {
        state: { candidateDetails: candidate },
      },
    );
  };
  const getMatchColor = (percentage: number) => {
    // if (percentage >= 90) return '#10b981'; // Green
    if (percentage >= 80) return '#EBF0FF'; // Blue
    // if (percentage >= 70) return '#f59e0b'; // Orange
    // return '#6b7280'; // Gray
    return '#EBF0FF';
  };

  // PDF Styles
  const pdfStyles = StyleSheet.create({
    breakdownBox: {
      backgroundColor: '#f9fafb',
      border: '1px solid #e5e7eb',
      borderRadius: 8,
      marginBottom: 15,
      padding: 15,
    },
    breakdownItem: {
      alignItems: 'center',
      flexDirection: 'row',
      marginBottom: 10,
    },
    breakdownLabel: {
      color: '#4b5563',
      fontSize: 12,
      width: 120,
    },
    breakdownValue: {
      color: '#374151',
      fontSize: 12,
      fontWeight: 'bold',
      textAlign: 'right',
      width: 60,
    },
    candidateName: {
      color: '#1f2937',
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 10,
    },
    considerationTag: {
      backgroundColor: '#fee2e2',
      border: '1px solid #fecaca',
      borderRadius: 4,
      color: '#991b1b',
      fontSize: 11,
      marginBottom: 5,
      padding: '4px 12px',
    },
    header: {
      borderBottom: '2px solid #6366f1',
      marginBottom: 20,
      paddingBottom: 10,
    },
    identityMatchBox: {
      alignItems: 'center',
      background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
      border: '1px solid #6ee7b7',
      borderRadius: 10,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 10,
      paddingBottom: 10,
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 10,
    },
    infoItem: {
      alignItems: 'center',
      color: '#6b7280',
      flexDirection: 'row',
      fontSize: 13,
      gap: 5,
    },
    infoRow: {
      flexDirection: 'row',
      gap: 15,
      marginBottom: 10,
    },
    matchScore: {
      textAlign: 'right',
    },
    matchScoreLabel: {
      color: '#9ca3af',
      fontSize: 11,
      fontWeight: 'bold',
      marginBottom: 5,
      textTransform: 'uppercase',
    },
    matchScoreValue: {
      color: '#10b981',
      fontSize: 38,
      fontWeight: 'bold',
    },
    nameRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 15,
    },

    noBreak: {
      break: false,
    },
    page: {
      fontFamily: 'Helvetica',
      fontSize: 12,
      padding: 30,
    },

    // Page break styles
    pageBreak: {
      break: true,
    },

    progressBar: {
      backgroundColor: '#e5e7eb',
      borderRadius: 4,
      flex: 1,
      height: 8,
      marginHorizontal: 10,
      overflow: 'hidden',
    },

    progressFill: {
      height: '100%',
    },

    rankBadge: {
      alignSelf: 'flex-start',
      backgroundColor: '#4f46e5',
      color: '#ffffff',
      fontSize: 14,
      fontWeight: 'bold',
      marginBottom: 10,
      padding: '4px 16px',
      width: 'auto',
    },

    section: {
      borderTop: '1px solid #e5e7eb',
      marginBottom: 20,
      paddingTop: 15,
    },

    sectionTitle: {
      color: '#166534',
      fontSize: 11,
      fontWeight: 'bold',
      marginBottom: 10,
      textTransform: 'uppercase',
    },

    skillTag: {
      backgroundColor: '#dbeafe',
      borderRadius: 20,
      color: '#1e40af',
      fontSize: 12,
      marginBottom: 5,
      padding: '4px 12px',
    },

    summaryBox: {
      backgroundColor: '#f9fafb',
      borderRadius: 8,
      marginBottom: 15,
      padding: 15,
    },

    summaryText: {
      color: '#374151',
      fontSize: 14,
      fontStyle: 'italic',
      lineHeight: 1.6,
    },
    tag: {
      backgroundColor: '#dcfce7',
      border: '1px solid #bbf7d0',
      borderRadius: 4,
      color: '#166534',
      fontSize: 11,
      marginBottom: 5,
      padding: '4px 12px',
    },
    tagContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 8,
    },
  });

  const identityPercentage = selectedCandidate
    ? Array.isArray(selectedCandidate.mathematicalBreakdown)
      ? (selectedCandidate.mathematicalBreakdown ?? []).find(
          (row: any) => row?.component === 'Identity Match',
        )
      : null
    : null;

  let matchedSkills: any[] = [];
  let secondarySkills: any[] = [];
  let primarySkillAnalysis: any = null;
  let secondarySkillAnalysis: any = null;

  if (selectedCandidate) {
    ((selectedCandidate.mathematicalBreakdown ?? []) as any[]).map(
      (row: any) => {
        if (row?.component === 'Primary Skills') {
          matchedSkills = matchedSkills.concat(row?.matchedSkills ?? []);
          primarySkillAnalysis = row?.skillAnalysis;
        }
        if (row?.component === 'Secondary Skills') {
          secondarySkills = secondarySkills.concat(row?.matchedSkills ?? []);
          secondarySkillAnalysis = row?.skillAnalysis;
        }
      },
    );
  }

  // PDF Document Component
  const CandidatePDFDocument = () => {
    if (!selectedCandidate) return null;
    const scoreBreakdown =
      Array.isArray(selectedCandidate.mathematicalBreakdown) &&
      selectedCandidate.mathematicalBreakdown?.length > 0
        ? selectedCandidate.mathematicalBreakdown.map(
            (row: any, index: number) => {
              const score = parseFloat(row?.score) || 0;
              const max = parseFloat(row?.maxPercentage) || 0;
              const percentage = Math.min(
                max > 0 ? (score / max) * 100 : 0,
                100,
              );
              const colors = [
                '#a855f7',
                '#06b6d4',
                '#f59e0b',
                '#10b981',
                '#6366f1', // Indigo for Secondary Skills (more visible)
              ];
              // Format score: remove trailing zeros (5.0 -> 5, 5.6 -> 5.6)
              const formattedScore =
                score % 1 === 0 ? score.toString() : score.toFixed(1);
              // Format max: always show as integer
              const formattedMax = Math.round(max).toString();
              return {
                color: colors[index % colors.length],
                identityClass: row?.identityClass,
                label: row?.component || 'Component',
                percentage,
                value: `${formattedScore}/${formattedMax}`,
              };
            },
          )
        : [];

    // Get location string
    const locationStr =
      selectedCandidate?.candidate?.city || selectedCandidate?.candidate?.state
        ? `${selectedCandidate?.candidate?.city || ''}${
            selectedCandidate?.candidate?.city &&
            selectedCandidate?.candidate?.state
              ? ', '
              : ''
          }${selectedCandidate?.candidate?.state || ''}`
        : '-';

    // Get experience string
    const experienceStr = selectedCandidate?.candidate?.overallExperience
      ? `${String(selectedCandidate?.candidate?.overallExperience)} Years`
      : '-';

    // Get work status string
    const workStatusStr = selectedCandidate?.candidate?.workStatus?.name || '-';
    return (
      <Document>
        <Page size="A4" style={pdfStyles.page} wrap>
          {/* Rank Badge */}
          {selectedCandidate?.rank && (
            <View style={pdfStyles.rankBadge}>
              <Text>#{selectedCandidate.rank}</Text>
            </View>
          )}
          {/* Header: Name and Match Score */}
          <View style={pdfStyles.nameRow} wrap={false}>
            <View>
              <Text style={pdfStyles.candidateName}>
                {(() => {
                  const first = selectedCandidate?.candidate?.firstName?.trim();
                  const middle =
                    selectedCandidate?.candidate?.middleName?.trim();
                  const last = selectedCandidate?.candidate?.lastName?.trim();
                  if (first || middle || last) {
                    return [first, middle, last].filter(Boolean).join(' ');
                  }
                  return '-';
                })() || ''}
              </Text>
              {(locationStr !== '-' ||
                experienceStr !== '-' ||
                workStatusStr !== '-') && (
                <View style={pdfStyles.infoRow}>
                  {locationStr !== '-' && (
                    <View style={pdfStyles.infoItem}>
                      <Text
                        style={{
                          color: '#ef4444',
                          fontSize: 16,
                          fontWeight: 'bold',
                          marginRight: 6,
                        }}>
                        •
                      </Text>
                      <Text style={{ color: '#6b7280', fontSize: 13 }}>
                        {locationStr}
                      </Text>
                    </View>
                  )}
                  {experienceStr !== '-' && (
                    <View style={pdfStyles.infoItem}>
                      <Text
                        style={{
                          color: '#92400e',
                          fontSize: 16,
                          fontWeight: 'bold',
                          marginRight: 6,
                        }}>
                        •
                      </Text>
                      <Text style={{ color: '#6b7280', fontSize: 13 }}>
                        {experienceStr}
                      </Text>
                    </View>
                  )}
                  {workStatusStr !== '-' && (
                    <View style={pdfStyles.infoItem}>
                      <Text
                        style={{
                          color: '#ef4444',
                          fontSize: 16,
                          fontWeight: 'bold',
                          marginRight: 6,
                        }}>
                        •
                      </Text>
                      <Text style={{ color: '#6b7280', fontSize: 13 }}>
                        {workStatusStr}
                      </Text>
                    </View>
                  )}
                </View>
              )}
            </View>
            <View style={pdfStyles.matchScore}>
              <Text style={pdfStyles.matchScoreLabel}>Match Score</Text>
              <Text style={pdfStyles.matchScoreValue}>
                {selectedCandidate?.matchPercentage}%
              </Text>
            </View>
          </View>

          {/* Score Breakdown */}
          {scoreBreakdown.length > 0 && (
            <View style={pdfStyles.breakdownBox} wrap={false}>
              <Text style={pdfStyles.sectionTitle}>SCORE BREAKDOWN (V2.1)</Text>
              {scoreBreakdown.map((item: any, index: number) => {
                if (item?.component === 'Identity Match') {
                  return null;
                }
                return (
                  <View key={index} style={pdfStyles.breakdownItem}>
                    <Text style={pdfStyles.breakdownLabel}>{item.label}</Text>
                    <View style={pdfStyles.progressBar}>
                      <View
                        style={[
                          pdfStyles.progressFill,
                          {
                            backgroundColor: item.color,
                            width: `${String(item.percentage)}%`,
                          },
                        ]}
                      />
                    </View>
                    <Text style={pdfStyles.breakdownValue}>{item.value}</Text>
                  </View>
                );
              })}
              {identityPercentage ? (
                <View
                  style={{
                    alignItems: 'center',
                    backgroundColor: (() => {
                      const status =
                        identityPercentage?.identityStatus?.toLowerCase();
                      if (status?.includes('exact match')) return '#d1fae5';
                      if (status?.includes('related role')) return '#fef3c7';
                      if (status?.includes('role mismatch')) return '#fee2e2';
                      return '#d1fae5'; // default to match
                    })(),
                    borderColor: (() => {
                      const status =
                        identityPercentage?.identityStatus?.toLowerCase();
                      if (status?.includes('exact match')) return '#6ee7b7';
                      if (status?.includes('related role')) return '#fcd34d';
                      if (status?.includes('role mismatch')) return '#f87171';
                      return '#6ee7b7'; // default to match
                    })(),
                    borderRadius: 10,
                    borderWidth: 1,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginBottom: 10,
                    paddingBottom: 10,
                    paddingLeft: 20,
                    paddingRight: 20,
                    paddingTop: 10,
                  }}>
                  <Text
                    style={{
                      color: '#6b7280',
                      fontSize: 12,
                      fontWeight: 'bold',
                    }}>
                    {identityPercentage?.component}
                  </Text>
                  <Text
                    style={{
                      color: (() => {
                        const status =
                          identityPercentage?.identityStatus?.toLowerCase();
                        if (status?.includes('exact match')) return '#047857';
                        if (status?.includes('related role')) return '#b45309';
                        if (status?.includes('role mismatch')) return '#dc2626';
                        return '#047857'; // default to match
                      })(),
                      fontSize: 12,
                      fontWeight: 'bold',
                      textAlign: 'right',
                    }}>
                    {identityPercentage?.identityStatus} (
                    {identityPercentage?.identityPercentage}%)
                  </Text>
                </View>
              ) : null}
            </View>
          )}

          {/* Summary */}
          {selectedCandidate?.justification && (
            <View style={pdfStyles.summaryBox} wrap={false}>
              <Text style={pdfStyles.summaryText}>
                {String(selectedCandidate.justification)}
              </Text>
            </View>
          )}

          {/* Strengths */}
          {Array.isArray(selectedCandidate?.strengths) &&
            selectedCandidate?.strengths?.length > 0 && (
              <View style={pdfStyles.section} wrap={false}>
                <Text style={pdfStyles.sectionTitle}>✓ Strengths</Text>
                <View style={pdfStyles.tagContainer}>
                  {selectedCandidate.strengths.map(
                    (strength: string, i: number) => (
                      <View key={i} style={pdfStyles.tag}>
                        <Text>✓ {strength}</Text>
                      </View>
                    ),
                  )}
                </View>
              </View>
            )}

          {/* Considerations */}
          {Array.isArray(selectedCandidate?.gapsConcerns) &&
            selectedCandidate?.gapsConcerns?.length > 0 && (
              <View style={pdfStyles.section} wrap={false}>
                <Text style={pdfStyles.sectionTitle}>⚠ Considerations</Text>
                <View style={pdfStyles.tagContainer}>
                  {selectedCandidate.gapsConcerns.map(
                    (concern: string, i: number) => (
                      <View key={i} style={pdfStyles.considerationTag}>
                        <Text>⚠ {concern}</Text>
                      </View>
                    ),
                  )}
                </View>
              </View>
            )}

          {/* Matched Skills */}
          {Array.isArray(matchedSkills) && matchedSkills?.length > 0 && (
            <View style={pdfStyles.section} wrap={false}>
              <Text style={pdfStyles.sectionTitle}>
                ✓ Matched Skills ({matchedSkills?.length})
              </Text>
              <View style={pdfStyles.tagContainer}>
                {matchedSkills?.map((s: any, i: number) => {
                  // Determine the symbol based on match type
                  const symbol =
                    s?.matchType === 'direct_primary'
                      ? '✓✓'
                      : s?.matchType === 'direct_secondary'
                      ? '✓'
                      : s?.matchType === 'ecosystem_primary'
                      ? '≈'
                      : s?.matchType === 'ecosystem_secondary'
                      ? '~'
                      : '✗✗';

                  // Determine the text to display
                  const displayText = [
                    'ecosystem_primary',
                    'ecosystem_secondary',
                  ].includes(s?.matchType)
                    ? `${symbol} ${String(s?.skill)} → ${String(
                        s?.matchedWith,
                      )}`
                    : `${symbol} ${String(s?.matchedWith)}`;

                  return (
                    <View key={i} style={pdfStyles.tag}>
                      <Text>{displayText}</Text>
                    </View>
                  );
                })}
              </View>
            </View>
          )}
        </Page>
      </Document>
    );
  };

  // Download PDF function
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleDownloadPDF = async () => {
    if (!selectedCandidate) return;
    try {
      const doc = <CandidatePDFDocument />;
      const asPdf = pdf(doc);
      const blob = await asPdf.toBlob();
      const name = (() => {
        const first = selectedCandidate?.candidate?.firstName?.trim();
        const middle = selectedCandidate?.candidate?.middleName?.trim();
        const last = selectedCandidate?.candidate?.lastName?.trim();
        if (first || middle || last) {
          return [first, middle, last].filter(Boolean).join(' ');
        }
        return 'Candidate';
      })();
      saveAs(blob, `${name}_Match_Details.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const displayData = users.length > 0 ? users : [];

  return (
    <div className={'more-candidate-table job-queue-table'}>
      <Table sx={{ minWidth: 650 }} aria-label="job queue table">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <div style={{ alignItems: 'center', display: 'flex' }}>
                {/* <Checkbox
                  checked={isAllSelected}
                  indeterminate={isIndeterminate}
                  onChange={(e) => onSelectAll(e.target.checked)}
                  sx={{
                    marginRight: '8px',
                    padding: '4px',
                  }}
                /> */}
                <Typography
                  sx={{
                    color: '#181d1f',
                    fontFamily: 'Inter',
                    fontSize: '13px',
                    fontWeight: 500,
                    lineHeight: 'normal',
                  }}>
                  Name
                </Typography>
              </div>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  color: '#181d1f',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}>
                Email
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  color: '#181d1f',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}>
                Phone
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  color: '#181d1f',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}>
                Location
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  color: '#181d1f',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}>
                Visa Status
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  color: '#181d1f',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}>
                Relocation Status
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  color: '#181d1f',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}>
                Pay
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  color: '#181d1f',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}>
                Match%
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  color: '#181d1f',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontWeight: 500,
                  lineHeight: 'normal',
                }}>
                Status
              </Typography>
            </TableCell>
            <TableCell sx={{ padding: '12px 16px' }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell
                colSpan={10}
                align="center"
                sx={{
                  padding: '20px',
                  textAlign: 'center',
                }}>
                <Loader newLoader />
              </TableCell>
            </TableRow>
          ) : displayData.length > 0 ? (
            displayData.map((row) => (
              <TableRow
                key={row.id}
                hover
                sx={{
                  '&:hover': {
                    backgroundColor: '#f9fafb',
                  },
                  cursor: 'pointer',
                }}
                onClick={() => navigateTo(row)}>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <div style={{ alignItems: 'center', display: 'flex' }}>
                    {/* <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() => onRowSelect(row.id)}
                      sx={{
                        marginRight: '8px',
                        padding: '4px',
                      }}
                    /> */}
                    <Typography
                      sx={{
                        color: '#181d1f',
                        fontFamily: 'Inter',
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: 'normal',
                      }}>
                      {(() => {
                        const first = row?.candidate?.firstName?.trim();
                        const middle = row?.candidate?.middleName?.trim();
                        const last = row?.candidate?.lastName?.trim();
                        if (first || middle || last) {
                          return [first, middle, last]
                            .filter(Boolean)
                            .join(' ');
                        }
                        return '-';
                      })()}
                    </Typography>
                  </div>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#181d1f',
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: 'normal',
                    }}>
                    {row?.candidate?.email || '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#181d1f',
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: 'normal',
                    }}>
                    {row?.candidate?.phone
                      ? formatPhoneNumber(row?.candidate?.phone)
                      : row?.candidate?.mobileNumber
                      ? formatPhoneNumber(row?.candidate?.mobileNumber)
                      : '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#181d1f',
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: 'normal',
                    }}>
                    {(() => {
                      const city = row?.candidate?.city?.trim() || '';
                      const state = row?.candidate?.state?.trim() || '';
                      const combined = [city, state].filter(Boolean).join(', ');
                      return combined || '-';
                    })()}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#181d1f',
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: 'normal',
                    }}>
                    {row?.candidate?.workStatus?.name || '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#181d1f',
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: 'normal',
                    }}>
                    {'-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#181d1f',
                      fontFamily: 'Inter',
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: 'normal',
                    }}>
                    {'-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    component={'div'}
                    style={{
                      alignItems: 'center',
                      backgroundColor: getMatchColor(row?.matchPercentage),
                      border: '1px solid #7995E8',
                      borderRadius: '9999px',
                      color: '#2453C3',
                      cursor: 'pointer',
                      display: 'flex',
                      fontFamily: 'Inter',
                      fontSize: '10px',
                      fontWeight: 600,
                      justifyContent: 'center',
                      lineHeight: '14px',
                      minHeight: '20px',
                      padding: '2px 4px',
                      width: '40px',
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedCandidate(row);
                      setOpenPercentageModal(true);
                    }}>
                    {row?.matchPercentage || '-'}%
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <CheckCircleIcon
                    sx={{
                      color: '#0E700E',
                      fontSize: '16px',
                    }}
                  />
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={10} align="center" sx={{ padding: '20px' }}>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontWeight: 400,
                  }}>
                  No Matches Found.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      {/* Score Modal */}
      <Modal
        open={openPercentageModal}
        onClose={() => setOpenPercentageModal(false)}
        disableAutoFocus
        disableEnforceFocus>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
            outline: 'none',
          }}>
          <Box
            sx={{
              bgcolor: '#ffffff',
              border: '1px solid #6366f1',
              borderRadius: '12px',
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '95vh',
              // maxWidth: '900px',
              overflow: 'hidden',
              position: 'relative',
              width: '80%',
            }}>
            <Box
              sx={{
                alignItems: 'center',
                backgroundColor: '#ffffff',
                display: 'flex',
                justifyContent: 'flex-end',
                padding: '8px 16px',
              }}>
              {/* Download PDF button commented out */}
              {/* <Button
                startIcon={<DownloadIcon />}
                onClick={handleDownloadPDF}
                size="small"
                sx={{
                  color: '#6366f1',
                  fontSize: '12px',
                  marginLeft: '40px',
                  textTransform: 'none',
                }}
                variant="outlined">
                Download PDF
              </Button> */}
              <IconButton
                size="small"
                onClick={() => setOpenPercentageModal(false)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            {/* Rank Badge - Top Left */}
            {selectedCandidate?.rank && (
              <Box
                sx={{
                  backgroundColor: '#4f46e5',
                  borderBottomRightRadius: '8px',
                  color: '#ffffff',
                  fontSize: '14px',
                  fontWeight: 800,
                  left: 0,
                  padding: '4px 16px',
                  position: 'absolute',
                  top: 0,
                  zIndex: 10,
                }}>
                #{selectedCandidate?.rank}
              </Box>
            )}

            {/* Fixed Goal Section */}
            <Box
              data-goal-container
              sx={{
                borderBottom: '1px solid #f3f4f6',
                flexShrink: 0,
                p: 2,
              }}>
              {goal &&
                (() => {
                  try {
                    const goalData =
                      typeof goal === 'string' ? JSON.parse(goal) : goal;
                    const introduction = goalData?.introduction;
                    const requiredIdentity = goalData?.requiredIdentity;
                    const mustHaveSkills = goalData?.skills?.mustHave || [];
                    const primarySkills = goalData?.skills?.primary || [];
                    const secondarySkills = goalData?.skills?.secondary || [];

                    const experienceText =
                      expFrom !== null && expFrom !== undefined
                        ? `${expFrom}${
                            expTo && expTo !== expFrom && expTo !== 0
                              ? `-${expTo}`
                              : '+'
                          } years`
                        : null;

                    return (
                      <>
                        <Box
                          sx={{
                            borderRadius: '8px',
                            height: `${goalSectionHeight}px`,
                            mb: 1.5,
                            overflowY: 'auto',
                            p: 1.5,
                          }}>
                          {/* Job Title Header */}
                          {jobTitle && (
                            <Box sx={{ mb: 1 }}>
                              <Typography
                                sx={{
                                  color: '#111827',
                                  fontSize: '18px',
                                  fontWeight: 700,
                                  mb: 0.5,
                                }}>
                                {jobTitle}
                              </Typography>
                              <Box
                                sx={{
                                  alignItems: 'center',
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: 1.5,
                                }}>
                                {requiredIdentity && (
                                  <Box
                                    sx={{
                                      backgroundColor: '#ede9fe',
                                      borderRadius: '4px',
                                      color: '#6b21a8',
                                      fontSize: '11px',
                                      fontWeight: 600,
                                      px: 1.5,
                                      py: 0.5,
                                    }}>
                                    {requiredIdentity}
                                  </Box>
                                )}
                                {experienceText && (
                                  <Box
                                    sx={{
                                      backgroundColor: '#f3f4f6',
                                      borderRadius: '4px',
                                      color: '#374151',
                                      fontSize: '11px',
                                      fontWeight: 600,
                                      px: 1.5,
                                      py: 0.5,
                                    }}>
                                    {experienceText}
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          )}

                          {introduction && (
                            <Typography
                              sx={{
                                color: '#374151',
                                fontSize: '13px',
                                fontWeight: 400,
                                lineHeight: 1.5,
                                mb: 1,
                              }}>
                              {introduction}
                            </Typography>
                          )}

                          {(mustHaveSkills.length > 0 ||
                            primarySkills.length > 0) && (
                            <Box sx={{ mb: 1 }}>
                              <Typography
                                sx={{
                                  alignItems: 'center',
                                  color: '#4f46e5',
                                  display: 'flex',
                                  fontSize: '11px',
                                  fontWeight: 600,
                                  gap: 0.5,
                                  mb: 1,
                                }}>
                                ● Primary Skills (
                                {mustHaveSkills.length + primarySkills.length})
                              </Typography>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: 0.75,
                                }}>
                                {mustHaveSkills.map(
                                  (skill: string, i: number) => (
                                    <Box
                                      key={`must-${i}`}
                                      sx={{
                                        backgroundColor: '#e0e7ff',
                                        borderRadius: '4px',
                                        color: '#4338ca',
                                        fontSize: '11px',
                                        fontWeight: 500,
                                        px: 1.5,
                                        py: 0.5,
                                      }}>
                                      {skill}
                                    </Box>
                                  ),
                                )}
                                {primarySkills.map(
                                  (skill: string, i: number) => (
                                    <Box
                                      key={`primary-${i}`}
                                      sx={{
                                        backgroundColor: '#e0e7ff',
                                        borderRadius: '4px',
                                        color: '#4338ca',
                                        fontSize: '11px',
                                        fontWeight: 500,
                                        px: 1.5,
                                        py: 0.5,
                                      }}>
                                      {skill}
                                    </Box>
                                  ),
                                )}
                              </Box>
                            </Box>
                          )}

                          {secondarySkills.length > 0 && (
                            <Box>
                              <Typography
                                sx={{
                                  alignItems: 'center',
                                  color: '#6b7280',
                                  display: 'flex',
                                  fontSize: '11px',
                                  fontWeight: 600,
                                  gap: 0.5,
                                  mb: 1,
                                }}>
                                ○ Secondary Skills ({secondarySkills.length})
                              </Typography>
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: 0.75,
                                }}>
                                {secondarySkills.map(
                                  (skill: string, i: number) => (
                                    <Box
                                      key={i}
                                      sx={{
                                        backgroundColor: '#f3f4f6',
                                        borderRadius: '4px',
                                        color: '#4b5563',
                                        fontSize: '11px',
                                        fontWeight: 500,
                                        px: 1.5,
                                        py: 0.5,
                                      }}>
                                      {skill}
                                    </Box>
                                  ),
                                )}
                              </Box>
                            </Box>
                          )}
                        </Box>
                        <Box
                          onMouseDown={handleMouseDown}
                          sx={{
                            '&:active': {
                              backgroundColor: '#3b82f6',
                            },
                            '&:hover': {
                              backgroundColor: '#60a5fa',
                            },
                            alignItems: 'center',
                            backgroundColor: isDragging ? '#3b82f6' : '#e5e7eb',
                            cursor: 'ns-resize',
                            display: 'flex',
                            height: '5px',
                            justifyContent: 'center',
                            transition: 'background-color 0.2s ease',
                            width: '100%',
                          }}>
                          <img
                            src={require('assets/images/split-v.svg').default}
                            alt="Resize"
                            style={{
                              height: 'auto',
                              rotate: '90deg',
                              width: '24px',
                            }}
                          />
                        </Box>
                      </>
                    );
                  } catch (e) {
                    return (
                      <>
                        <Box
                          sx={{
                            backgroundColor: '#f0fdf4',
                            border: '1px solid #86efac',
                            borderRadius: '8px',
                            height: `${goalSectionHeight}px`,
                            mb: 1.5,
                            overflowY: 'auto',
                            p: 1.5,
                          }}>
                          <Typography
                            sx={{
                              color: '#166534',
                              fontSize: '11px',
                              fontWeight: 700,
                              letterSpacing: '0.5px',
                              mb: 1,
                              textTransform: 'uppercase',
                            }}>
                            Goal
                          </Typography>
                          <Typography
                            sx={{
                              color: '#374151',
                              fontSize: '13px',
                              fontWeight: 400,
                              lineHeight: 1.6,
                            }}>
                            {typeof goal === 'string'
                              ? goal
                              : JSON.stringify(goal)}
                          </Typography>
                        </Box>
                        <Box
                          onMouseDown={handleMouseDown}
                          sx={{
                            '&:active': {
                              backgroundColor: '#3b82f6',
                            },
                            '&:hover': {
                              backgroundColor: '#60a5fa',
                            },
                            alignItems: 'center',
                            backgroundColor: isDragging ? '#3b82f6' : '#e5e7eb',
                            cursor: 'ns-resize',
                            display: 'flex',
                            height: '5px',
                            justifyContent: 'center',
                            transition: 'background-color 0.2s ease',
                            width: '100%',
                          }}>
                          <img
                            src={require('assets/images/split-v.svg').default}
                            alt="Resize"
                            style={{
                              height: 'auto',
                              rotate: '90deg',
                              width: '24px',
                            }}
                          />
                        </Box>
                      </>
                    );
                  }
                })()}
            </Box>

            {/* Scrollable Content */}
            <Box sx={{ flex: 1, overflowY: 'auto', p: 4 }}>
              {/* Header: Name and Match Score */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 3,
                  mt: 1,
                }}>
                <Box>
                  <Typography
                    sx={{
                      color: '#1f2937',
                      fontSize: '24px',
                      fontWeight: 700,
                    }}>
                    {(() => {
                      const first =
                        selectedCandidate?.candidate?.firstName?.trim();
                      const middle =
                        selectedCandidate?.candidate?.middleName?.trim();
                      const last =
                        selectedCandidate?.candidate?.lastName?.trim();
                      if (first || middle || last) {
                        return [first, middle, last].filter(Boolean).join(' ');
                      }
                      return '-';
                    })() || ''}
                  </Typography>
                  {(selectedCandidate?.candidate?.city ||
                    selectedCandidate?.candidate?.state ||
                    selectedCandidate?.candidate?.overallExperience ||
                    selectedCandidate?.candidate?.workStatus?.name) && (
                    <Box
                      sx={{
                        alignItems: 'center',
                        display: 'flex',
                        gap: 2,
                        mt: 1,
                      }}>
                      {(selectedCandidate?.candidate?.city ||
                        selectedCandidate?.candidate?.state) && (
                        <Box
                          sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 0.5,
                          }}>
                          <LocationOnIcon
                            sx={{ color: '#ef4444', fontSize: '16px' }}
                          />
                          <Typography
                            sx={{ color: '#6b7280', fontSize: '13px' }}>
                            {selectedCandidate?.candidate?.city || ''}
                            {selectedCandidate?.candidate?.city &&
                            selectedCandidate?.candidate?.state
                              ? ', '
                              : ''}
                            {selectedCandidate?.candidate?.state}
                          </Typography>
                        </Box>
                      )}
                      {selectedCandidate?.candidate?.overallExperience && (
                        <Box
                          sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 0.5,
                          }}>
                          <WorkIcon
                            sx={{ color: '#92400e', fontSize: '16px' }}
                          />
                          <Typography
                            sx={{ color: '#6b7280', fontSize: '13px' }}>
                            {selectedCandidate?.candidate?.overallExperience}{' '}
                            Years
                          </Typography>
                        </Box>
                      )}
                      {selectedCandidate?.candidate?.workStatus?.name && (
                        <Box
                          sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 0.5,
                          }}>
                          <RocketLaunchIcon
                            sx={{ color: '#ef4444', fontSize: '16px' }}
                          />
                          <Typography
                            sx={{ color: '#6b7280', fontSize: '13px' }}>
                            {selectedCandidate?.candidate?.workStatus?.name}
                          </Typography>
                        </Box>
                      )}
                      {selectedCandidate?.candidate?.identity && (
                        <Box
                          sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 0.5,
                          }}>
                          <DomainIcon
                            sx={{ color: '#6b7280', fontSize: '16px' }}
                          />
                          <Typography
                            sx={{
                              color: '#6b7280',
                              fontSize: '12px',
                              fontWeight: 400,
                            }}>
                            {selectedCandidate?.candidate?.identity}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  )}
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                  <Typography
                    sx={{
                      color: '#9ca3af',
                      fontSize: '11px',
                      fontWeight: 700,
                      textTransform: 'uppercase',
                    }}>
                    Match Score
                  </Typography>
                  <Typography
                    sx={{
                      color: '#10b981',
                      fontSize: '38px',
                      fontWeight: 900,
                      lineHeight: 1,
                    }}>
                    {selectedCandidate?.matchPercentage}%
                  </Typography>
                  <Box
                    sx={{
                      bgcolor: '#f3f4f6',
                      borderRadius: '2px',
                      height: '4px',
                      ml: 'auto',
                      mt: 1,
                      overflow: 'hidden',
                      width: '60px',
                    }}>
                    <Box
                      sx={{
                        bgcolor: '#3b82f6',
                        height: '100%',
                        width: `${selectedCandidate?.matchPercentage}%`,
                      }}
                    />
                  </Box>
                </Box>
              </Box>

              {/* Score Breakdown - Grid Layout */}
              {Array.isArray(selectedCandidate?.mathematicalBreakdown) &&
                selectedCandidate?.mathematicalBreakdown?.length > 0 && (
                  <Box
                    sx={{
                      display: 'grid',
                      gap: 2,
                      gridTemplateColumns: 'repeat(3, 1fr)',
                      mb: 4,
                    }}>
                    {selectedCandidate.mathematicalBreakdown.map(
                      (row: any, index: number) => {
                        if (
                          row?.component === 'Identity Match' ||
                          row?.component === 'Secondary Skills'
                        ) {
                          return null;
                        }

                        const score = parseFloat(row?.score) || 0;
                        const max = parseFloat(row?.maxPercentage) || 0;
                        const percentage = Math.min(
                          max > 0 ? (score / max) * 100 : 0,
                          100,
                        );
                        // Ensure percentage is a valid number
                        const validPercentage = isNaN(percentage)
                          ? 0
                          : Math.max(0, percentage);
                        const colors = [
                          '#a855f7',
                          '#06b6d4',
                          '#f59e0b',
                          '#10b981',
                          '#6366f1',
                        ];
                        const color = colors[index % colors.length];

                        // Format score: remove trailing zeros (5.0 -> 5, 5.6 -> 5.6)
                        const formattedScore =
                          score % 1 === 0 ? score.toString() : score.toFixed(1);
                        // Format max: always show as integer
                        const formattedMax = Math.round(max).toString();

                        return (
                          <Box key={index}>
                            <Typography
                              sx={{
                                color: '#6b7280',
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '10px',
                                fontWeight: 500,
                                letterSpacing: '0.5px',
                                mb: 0.5,
                                textTransform: 'uppercase',
                              }}>
                              {row?.component || ''}
                            </Typography>
                            <Box
                              sx={{
                                bgcolor: '#e5e7eb',
                                borderRadius: '2px',
                                height: '6px',
                                mb: 0.5,
                                overflow: 'hidden',
                                position: 'relative',
                                width: '100%',
                              }}>
                              <Box
                                sx={{
                                  bgcolor: color,
                                  height: '100%',
                                  transition: 'width 0.3s ease',
                                  width: `${validPercentage}%`,
                                }}
                              />
                            </Box>
                            <Typography
                              sx={{
                                color: '#111827',
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '11px',
                                fontWeight: 600,
                                textAlign: 'right',
                              }}>
                              {formattedScore}/{formattedMax}
                            </Typography>
                          </Box>
                        );
                      },
                    )}
                    {/* {identityPercentage && (
                      <Box sx={{ gridColumn: 'span 3' }}>
                        <Typography
                          sx={{
                            color: '#6b7280',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '10px',
                            fontWeight: 500,
                            letterSpacing: '0.5px',
                            mb: 0.5,
                            textTransform: 'uppercase',
                          }}>
                          {identityPercentage?.component}
                        </Typography>
                        <Box
                          sx={{
                            bgcolor: (() => {
                              const status =
                                identityPercentage?.identityStatus?.toLowerCase();
                              if (status?.includes('exact match'))
                                return '#10b981';
                              if (status?.includes('related role'))
                                return '#f59e0b';
                              if (status?.includes('role mismatch'))
                                return '#ef4444';
                              return '#10b981';
                            })(),
                            borderRadius: '2px',
                            height: '6px',
                            mb: 0.5,
                            width: '100%',
                          }}
                        />
                        <Typography
                          sx={{
                            color: (() => {
                              const status =
                                identityPercentage?.identityStatus?.toLowerCase();
                              if (status?.includes('exact match'))
                                return '#047857';
                              if (status?.includes('related role'))
                                return '#b45309';
                              if (status?.includes('role mismatch'))
                                return '#dc2626';
                              return '#047857';
                            })(),
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '11px',
                            fontWeight: 600,
                            textAlign: 'right',
                          }}>
                          ✓ {identityPercentage?.identityStatus} (
                          {identityPercentage?.identityPercentage}%)
                        </Typography>
                      </Box>
                    )} */}
                  </Box>
                )}

              {/* AI Summary Text */}
              {selectedCandidate?.justification && (
                <Box
                  sx={{
                    bgcolor: '#f9fafb',
                    borderRadius: '8px',
                    mb: 3,
                    p: 2,
                  }}>
                  <Typography
                    sx={{
                      color: '#374151',
                      fontSize: '14px',
                      fontStyle: 'italic',
                      lineHeight: 1.6,
                    }}>
                    {String(selectedCandidate?.justification)}
                  </Typography>
                </Box>
              )}

              {/* Role/Title Match Analysis */}
              {(() => {
                const breakdown =
                  (selectedCandidate?.mathematicalBreakdown as any[]) ?? [];
                const roleTitleMatch = breakdown.find(
                  (row: any) => row?.component === 'Role/Title Match',
                );
                if (!roleTitleMatch) return null;

                const roleHistory = roleTitleMatch?.roleHistory || [];
                const analysis = roleTitleMatch?.roleTitleAnalysis || {};
                const formulas = analysis?.formulas || {};

                return (
                  <Box
                    sx={{
                      borderTop: '1px solid #e5e7eb',
                      mb: 4,
                      pt: 4,
                    }}>
                    <Typography
                      sx={{
                        color: '#374151',
                        fontSize: '0.9rem',
                        fontWeight: 600,
                        mb: 1.5,
                      }}>
                      Role/Title score calculation
                    </Typography>

                    <Box
                      sx={{
                        background:
                          'linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%)',
                        border: '1px solid #f9a8d4',
                        borderRadius: '8px',
                        mb: 2,
                        p: '12px 16px',
                      }}>
                      <Box sx={{ mb: 1.5 }}>
                        <Typography
                          sx={{
                            color: '#374151',
                            fontSize: '0.9rem',
                            fontWeight: 600,
                          }}>
                          Score:{' '}
                          <Typography
                            component="span"
                            sx={{
                              color: (() => {
                                const score =
                                  analysis.calculatedScore ||
                                  roleTitleMatch?.score ||
                                  0;
                                const maxScore =
                                  analysis.maxScore ||
                                  roleTitleMatch?.maxPercentage ||
                                  35;
                                const percentage = (score / maxScore) * 100;

                                if (percentage >= 85) return '#16a34a'; // Green
                                if (percentage >= 70) return '#eab308'; // Yellow
                                if (percentage >= 50) return '#f97316'; // Orange
                                return '#dc2626'; // Red
                              })(),
                              fontSize: '0.95rem',
                              fontWeight: 700,
                            }}>
                            {analysis.calculatedScore || roleTitleMatch?.score}
                          </Typography>
                          <Typography
                            component="span"
                            sx={{
                              color: '#9ca3af',
                              fontSize: '0.9rem',
                              fontWeight: 400,
                            }}>
                            {' '}
                            /{' '}
                            {analysis.maxScore ||
                              roleTitleMatch?.maxPercentage}{' '}
                            points
                          </Typography>
                        </Typography>
                      </Box>

                      {analysis.calculationSteps &&
                        analysis.calculationSteps.length > 0 && (
                          <Box
                            sx={{
                              bgcolor: 'rgba(236, 72, 153, 0.08)',
                              borderLeft: '3px solid #ec4899',
                              borderRadius: '4px',
                              mb: 1,
                              overflow: 'hidden',
                              p: 1.5,
                            }}>
                            <Typography
                              sx={{
                                color: '#4b5563',
                                fontSize: '0.85rem',
                                fontWeight: 600,
                                mb: 1.25,
                              }}>
                              Calculation:
                            </Typography>
                            {analysis.calculationSteps.map(
                              (step: any, index: number) => (
                                <Box
                                  key={index}
                                  sx={{
                                    alignItems: 'center',
                                    borderBottom:
                                      index <
                                      analysis.calculationSteps.length - 1
                                        ? '1px solid rgba(255, 255, 255, 0.6)'
                                        : 'none',
                                    display: 'flex',
                                    pb:
                                      index <
                                      analysis.calculationSteps.length - 1
                                        ? 1.25
                                        : 0,
                                    pt: index > 0 ? 1.25 : 0,
                                  }}>
                                  <Box
                                    sx={{
                                      bgcolor: 'rgba(236, 72, 153, 0.3)',
                                      borderRadius: '3px',
                                      color: '#831843',
                                      flexShrink: 0,
                                      fontSize: '0.75rem',
                                      fontWeight: 600,
                                      mr: 1.5,
                                      px: 1.25,
                                      py: 0.5,
                                    }}>
                                    Step {step.step}
                                  </Box>
                                  <Typography
                                    sx={{
                                      color: '#374151',
                                      flex: 1,
                                      fontFamily: 'monospace',
                                      fontSize: '0.75rem',
                                      lineHeight: 1.8,
                                    }}>
                                    {step.value}
                                  </Typography>
                                </Box>
                              ),
                            )}
                          </Box>
                        )}

                      <Box
                        sx={{
                          borderTop: '1px dashed #e5e7eb',
                          mt: 1,
                          pt: 1,
                        }}>
                        <Typography
                          sx={{
                            color: '#6b7280',
                            fontSize: '0.8rem',
                            lineHeight: 1.5,
                          }}>
                          Aggregation: {analysis.aggregationMethod}; Trajectory:{' '}
                          {analysis.trajectory}; T_adj ={' '}
                          {analysis.trajectory === 'ascending'
                            ? '+0.05'
                            : analysis.trajectory === 'descending'
                            ? '-0.05'
                            : '0'}
                          ; {roleHistory.length}(roles) evaluated; S_agg:{' '}
                          {analysis.s_agg}; W_current: {analysis.w_current};
                          W_best: {analysis.w_best_historical}
                        </Typography>
                      </Box>

                      {Object.keys(formulas).length > 0 && (
                        <Box sx={{ mt: 1.5 }}>
                          <Box
                            onClick={() =>
                              setFormulaStepsExpanded(!formulaStepsExpanded)
                            }
                            sx={{
                              '&:hover': {
                                opacity: 0.8,
                              },
                              alignItems: 'center',
                              cursor: 'pointer',
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}>
                            <Typography
                              sx={{
                                alignItems: 'center',
                                color: '#4b5563',
                                display: 'flex',
                                fontSize: '0.85rem',
                                fontWeight: 600,
                                gap: 0.5,
                              }}>
                              <Typography
                                component="span"
                                sx={{
                                  display: 'inline-block',
                                  fontSize: '14px',
                                  transform: formulaStepsExpanded
                                    ? 'rotate(90deg)'
                                    : 'rotate(0deg)',
                                  transition: 'transform 0.2s',
                                }}>
                                ›
                              </Typography>
                              Formula steps
                            </Typography>
                          </Box>

                          {formulaStepsExpanded && (
                            <Box
                              sx={{
                                background: 'rgba(255, 255, 255, 0.6)',
                                borderRadius: '6px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '6px',
                                mt: 1,
                                p: '10px',
                              }}>
                              {Object.entries(formulas).map(
                                ([key, value]: [string, any]) => (
                                  <Box key={key}>
                                    <Typography
                                      sx={{
                                        color: '#4b5563',
                                        fontSize: '0.8rem',
                                      }}>
                                      {/* <Typography
                                        component="span"
                                        sx={{
                                          color: '#831843',
                                          fontFamily: 'monospace',
                                          fontWeight: 500,
                                          mr: 0.75,
                                          textTransform: 'capitalize',
                                        }}>
                                        {key
                                          .replace(/_/g, ' ')
                                          .replace(/^step(\d+) /, 'Step$1 ')}
                                        :
                                      </Typography> */}
                                      {String(value)}
                                    </Typography>
                                  </Box>
                                ),
                              )}
                            </Box>
                          )}
                        </Box>
                      )}
                    </Box>

                    {roleHistory.length > 0 && (
                      <Box sx={{ mt: 1.5 }}>
                        <Typography
                          sx={{
                            color: '#374151',
                            fontSize: '0.85rem',
                            fontWeight: 600,
                            mb: 1,
                          }}>
                          Role History (weighted)
                        </Typography>
                        <Box
                          sx={{
                            border: '1px solid #e5e7eb',
                            borderRadius: '8px',
                            overflow: 'hidden',
                          }}>
                          <Box
                            component="table"
                            sx={{
                              borderCollapse: 'collapse',
                              fontSize: '0.8rem',
                              width: '100%',
                            }}>
                            <Box component="thead">
                              <Box component="tr">
                                <Box
                                  component="th"
                                  sx={{
                                    background: 'rgba(236, 72, 153, 0.12)',
                                    border: '1px solid #e5e7eb',
                                    color: '#831843',
                                    fontWeight: 600,
                                    p: '6px 10px',
                                    textAlign: 'left',
                                  }}>
                                  Title
                                </Box>
                                <Box
                                  component="th"
                                  sx={{
                                    background: 'rgba(236, 72, 153, 0.12)',
                                    border: '1px solid #e5e7eb',
                                    color: '#831843',
                                    fontWeight: 600,
                                    p: '6px 10px',
                                    textAlign: 'left',
                                    width: '60px',
                                  }}>
                                  Rank
                                </Box>
                                <Box
                                  component="th"
                                  sx={{
                                    background: 'rgba(236, 72, 153, 0.12)',
                                    border: '1px solid #e5e7eb',
                                    color: '#831843',
                                    fontWeight: 600,
                                    p: '6px 10px',
                                    textAlign: 'left',
                                    width: '70px',
                                  }}>
                                  S_base
                                </Box>
                                <Box
                                  component="th"
                                  sx={{
                                    background: 'rgba(236, 72, 153, 0.12)',
                                    border: '1px solid #e5e7eb',
                                    color: '#831843',
                                    fontWeight: 600,
                                    p: '6px 10px',
                                    textAlign: 'left',
                                    width: '80px',
                                  }}>
                                  W_role
                                </Box>
                                <Box
                                  component="th"
                                  sx={{
                                    background: 'rgba(236, 72, 153, 0.12)',
                                    border: '1px solid #e5e7eb',
                                    color: '#831843',
                                    fontWeight: 600,
                                    p: '6px 10px',
                                    textAlign: 'left',
                                  }}>
                                  w_role_calculation
                                </Box>
                                <Box
                                  component="th"
                                  sx={{
                                    background: 'rgba(236, 72, 153, 0.12)',
                                    border: '1px solid #e5e7eb',
                                    color: '#831843',
                                    fontWeight: 600,
                                    p: '6px 10px',
                                    textAlign: 'left',
                                  }}>
                                  Tenure_calculation
                                </Box>
                                <Box
                                  component="th"
                                  sx={{
                                    background: 'rgba(236, 72, 153, 0.12)',
                                    border: '1px solid #e5e7eb',
                                    color: '#831843',
                                    fontWeight: 600,
                                    p: '6px 10px',
                                    textAlign: 'left',
                                  }}>
                                  Reason
                                </Box>
                              </Box>
                            </Box>
                            <Box component="tbody">
                              {roleHistory.map((role: any, index: number) => (
                                <Box
                                  key={index}
                                  component="tr"
                                  sx={{
                                    '&:nth-of-type(even)': {
                                      background: 'rgba(255, 255, 255, 0.6)',
                                    },
                                  }}>
                                  <Box
                                    component="td"
                                    sx={{
                                      border: '1px solid #e5e7eb',
                                      color: '#374151',
                                      p: '6px 10px',
                                    }}>
                                    {role.designation}
                                  </Box>
                                  <Box
                                    component="td"
                                    sx={{
                                      border: '1px solid #e5e7eb',
                                      color: '#6b7280',
                                      p: '6px 10px',
                                    }}>
                                    {role.rank}
                                  </Box>
                                  <Box
                                    component="td"
                                    sx={{
                                      border: '1px solid #e5e7eb',
                                      color: '#6b7280',
                                      p: '6px 10px',
                                    }}>
                                    {role.s_base}
                                  </Box>
                                  <Box
                                    component="td"
                                    sx={{
                                      border: '1px solid #e5e7eb',
                                      color: '#6b7280',
                                      p: '6px 10px',
                                    }}>
                                    {role.w_role?.toFixed(2)}
                                  </Box>
                                  <Box
                                    component="td"
                                    sx={{
                                      border: '1px solid #e5e7eb',
                                      p: '6px 10px',
                                    }}>
                                    <Box
                                      sx={{
                                        background: 'rgba(251, 207, 232, 0.3)',
                                        borderRadius: '4px',
                                        color: '#831843',
                                        display: 'inline-block',
                                        fontFamily: 'monospace',
                                        fontSize: '0.8rem',
                                        px: 1,
                                        py: 0.5,
                                      }}>
                                      {role.w_role_calculation}
                                    </Box>
                                  </Box>
                                  <Box
                                    component="td"
                                    sx={{
                                      border: '1px solid #e5e7eb',
                                      p: '6px 10px',
                                    }}>
                                    <Box
                                      sx={{
                                        background: 'rgba(251, 207, 232, 0.3)',
                                        borderRadius: '4px',
                                        color: '#831843',
                                        display: 'inline-block',
                                        fontFamily: 'monospace',
                                        fontSize: '0.8rem',
                                        px: 1,
                                        py: 0.5,
                                      }}>
                                      {role.tenure_calculation || 'N/A'}
                                    </Box>
                                  </Box>
                                  <Box
                                    component="td"
                                    sx={{
                                      border: '1px solid #e5e7eb',
                                      color: '#6b7280',
                                      p: '6px 10px',
                                    }}>
                                    {role.reason}
                                  </Box>
                                </Box>
                              ))}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>
                );
              })()}

              {/* Strengths Section */}
              {/* {Array.isArray(selectedCandidate?.strengths) &&
                selectedCandidate?.strengths?.length > 0 && (
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      sx={{
                        alignItems: 'center',
                        color: '#4b5563',
                        display: 'flex',
                        fontSize: '13px',
                        fontWeight: 700,
                        gap: 0.5,
                        mb: 1.5,
                      }}>
                      ✓ Strengths
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {selectedCandidate?.strengths?.map((s, i) => (
                        <Box
                          key={i}
                          sx={{
                            bgcolor: '#dcfce7',
                            border: '1px solid #bbf7d0',
                            borderRadius: '4px',
                            color: '#166534',
                            fontSize: '11px',
                            px: 1.5,
                            py: 0.5,
                          }}>
                          ✓ {s}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )} */}

              {/* Considerations Section */}
              {/* {Array.isArray(selectedCandidate?.gapsConcerns) &&
                selectedCandidate?.gapsConcerns?.length > 0 && (
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      sx={{
                        alignItems: 'center',
                        color: '#4b5563',
                        display: 'flex',
                        fontSize: '13px',
                        fontWeight: 700,
                        gap: 0.5,
                        mb: 1.5,
                      }}>
                      ⚠ Considerations
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {selectedCandidate?.gapsConcerns?.map((c, i) => (
                        <Box
                          key={i}
                          sx={{
                            bgcolor: '#fee2e2',
                            border: '1px solid #fecaca',
                            borderRadius: '4px',
                            color: '#991b1b',
                            fontSize: '11px',
                            px: 1.5,
                            py: 0.5,
                          }}>
                          ⚠ {c}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )} */}

              {(primarySkillAnalysis || secondarySkillAnalysis) && (
                <Box sx={{ borderTop: '1px solid #e5e7eb', mb: 3, pt: 4 }}>
                  <Box
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      justifyContent: 'space-between',
                      mb: 3,
                    }}>
                    <Typography
                      sx={{
                        color: '#111827',
                        fontSize: '13px',
                        fontWeight: 700,
                        textTransform: 'uppercase',
                      }}>
                      SKILL ANALYSIS
                    </Typography>
                    <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                      <CheckCircleIcon
                        sx={{ color: '#10b981', fontSize: '16px' }}
                      />
                      <Typography
                        sx={{
                          color: '#374151',
                          fontFamily: 'Inter, sans-serif',
                          fontSize: '12px',
                          fontWeight: 500,
                        }}>
                        {matchedSkills?.length} Primary Skill
                      </Typography>
                    </Box>
                  </Box>

                  {/* Primary Matched Skills Static Card */}
                  {primarySkillAnalysis && (
                    <Box sx={{ mb: 3 }}>
                      <Box
                        sx={{
                          alignItems: 'center',
                          bgcolor: '#dbeafe',
                          borderRadius: '8px',
                          display: 'flex',
                          gap: 2,
                          px: 2,
                          py: 1.5,
                        }}>
                        <Box
                          sx={{
                            bgcolor: '#10b981',
                            borderRadius: '2px',
                            height: '24px',
                            width: '3px',
                          }}
                        />
                        <Box
                          sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 4,
                          }}>
                          <Typography
                            sx={{
                              color: '#374151',
                              fontFamily: 'Inter, sans-serif',
                              fontSize: '12px',
                              fontWeight: 600,
                            }}>
                            Primary Skills:
                          </Typography>
                          <Typography
                            sx={{
                              color: '#374151',
                              fontFamily: 'JetBrains Mono, monospace',
                              fontSize: '12px',
                              letterSpacing: '-0.3px',
                            }}>
                            {primarySkillAnalysis?.calculation}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}

                  {/* Secondary Matched Skills Static Card */}
                  {secondarySkills?.length > 0 && (
                    <Box sx={{ mb: 3 }}>
                      <Box
                        sx={{
                          alignItems: 'center',
                          bgcolor: '#faf5ff',
                          borderRadius: '8px',
                          display: 'flex',
                          gap: 2,
                          px: 2,
                          py: 1.5,
                        }}>
                        <Box
                          sx={{
                            bgcolor: '#8b5cf6',
                            borderRadius: '2px',
                            height: '24px',
                            width: '3px',
                          }}
                        />
                        <Box
                          sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 4,
                          }}>
                          <Typography
                            sx={{
                              color: '#6b21a8',
                              fontFamily: 'Inter, sans-serif',
                              fontSize: '12px',
                              fontWeight: 600,
                            }}>
                            Secondary Skills:
                          </Typography>
                          <Typography
                            sx={{
                              color: '#374151',
                              fontFamily: 'JetBrains Mono, monospace',
                              fontSize: '12px',
                              letterSpacing: '-0.3px',
                            }}>
                            {secondarySkillAnalysis?.calculation}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Box>
              )}

              {/* Primary Matched Skills */}
              {Array.isArray(matchedSkills) && matchedSkills?.length > 0 && (
                <Box sx={{ mb: 3 }}>
                  <Typography
                    sx={{
                      alignItems: 'center',
                      color: '#10b981',
                      display: 'flex',
                      fontSize: '11px',
                      fontWeight: 600,
                      gap: 0.5,
                      mb: 1.5,
                      textTransform: 'uppercase',
                    }}>
                    <CheckCircleIcon
                      sx={{ color: '#10b981', fontSize: '14px' }}
                    />{' '}
                    PRIMARY SKILLS MATCHED ({matchedSkills?.length})
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {matchedSkills?.map((s, i) => (
                      <Box
                        key={i}
                        sx={{
                          bgcolor:
                            s?.score === 0.7
                              ? 'rgba(99,102,241,0.1)'
                              : '#dcfce7',
                          borderRadius: '6px',
                          color: s?.score === 0.7 ? '#6366f1' : '#15803d',
                          fontSize: '11px',
                          fontWeight: 500,
                          px: 1.5,
                          py: 0.5,
                        }}>
                        {s?.matchType === 'direct_primary'
                          ? '✓✓'
                          : s?.matchType === 'direct_secondary'
                          ? '✓'
                          : s?.matchType === 'ecosystem_primary'
                          ? '≈'
                          : s?.matchType === 'ecosystem_secondary'
                          ? '~'
                          : ''}{' '}
                        {['ecosystem_primary', 'ecosystem_secondary'].includes(
                          s?.matchType,
                        ) ? (
                          <span>
                            <span
                              style={{
                                fontWeight: 'bold',
                              }}>
                              {`${String(s?.skill)}`}
                            </span>{' '}
                            {'→'} <span>{`${String(s?.matchedWith)}`}</span>{' '}
                            {s?.score ? `(${s.score})` : ''}
                          </span>
                        ) : (
                          <span>
                            {s?.matchedWith} {s?.score ? `(${s.score})` : ''}
                          </span>
                        )}
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}

              {/* Secondary Skills */}
              {Array.isArray(secondarySkills) &&
                secondarySkills?.length > 0 && (
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      sx={{
                        alignItems: 'center',
                        color: '#15803d',
                        display: 'flex',
                        fontSize: '13px',
                        fontWeight: 700,
                        gap: 0.5,
                        mb: 1.5,
                      }}>
                      ✓ Secondary Matched Skills ({secondarySkills?.length})
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {secondarySkills?.map((s, i) => (
                        // <Tooltip
                        //   key={i}
                        //   title={s.matchType}
                        //   arrow
                        //   placement="bottom"
                        //   classes={{
                        //     arrow: 'job-header-tooltip-arrow',
                        //     tooltip: 'job-header-tooltip',
                        //   }}>
                        <Box
                          sx={{
                            bgcolor:
                              s?.score === 0.7
                                ? 'rgba(99,102,241,0.1)'
                                : '#f0fdf4',
                            border:
                              s?.score === 0.7
                                ? '1px solid #c7d2fe'
                                : '1px solid #dcfce7',
                            borderRadius: '4px',
                            color: s?.score === 0.7 ? '#6366f1' : '#15803d',
                            fontSize: '11px',
                            px: 1.5,
                            py: 0.5,
                          }}>
                          {s?.matchType === 'direct_primary'
                            ? '✓✓'
                            : s?.matchType === 'direct_secondary'
                            ? '✓'
                            : s?.matchType === 'ecosystem_primary'
                            ? '≈'
                            : s?.matchType === 'ecosystem_secondary'
                            ? '~'
                            : ''}{' '}
                          {[
                            'ecosystem_primary',
                            'ecosystem_secondary',
                          ].includes(s?.matchType) ? (
                            <span>
                              <span
                                style={{
                                  fontWeight: 'bold',
                                }}>
                                {`${String(s?.skill)}`}
                              </span>{' '}
                              {'→'} <span>{`${String(s?.matchedWith)}`}</span>{' '}
                              {s?.score ? `(${s.score})` : ''}
                            </span>
                          ) : (
                            <span>
                              {s?.matchedWith} {s?.score ? `(${s.score})` : ''}
                            </span>
                          )}
                        </Box>
                        // </Tooltip>
                      ))}
                    </Box>
                  </Box>
                )}
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default CandidateTable;
